<template>
  <div>
    <nav-bar />
    <v-container class="mt-10 pt-5">
      <!-- Page Header ########################################### -->
      <v-container>
        <v-row align="end">
          <v-col>
            <div class="page-title">
              <a @click.stop="goToSecretariesManagement"
                ><v-icon class="mr-3">fal fa-arrow-left</v-icon></a
              >
              <h1>{{ moduleTitle }} de Secretaria</h1>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <v-form ref="registerSecretaryForm" v-model="isSecretaryFormValid">
        <v-container>
          <!-- Card-1 -->
          <v-card elevation="8" class="pb-4">
            <!--card title-->
            <v-card-title class="pb-0">
              <v-container class="d-flex align-center justify-space-between">
                <span class="list-labels">Dados básicos</span>
                <div class="d-flex flex-row align-center">
                  <span class="list-labels">Inativo</span>
                  <v-switch
                    class="ml-4"
                    inset
                    v-model="secretaryActive"
                  ></v-switch>
                </div>
              </v-container>
            </v-card-title>

            <!--card content-->
            <v-card-text class="py-0">
              <v-container py-0>
                <v-row>
                  <!-- avatar ###################################### -->
                  <v-col class="flex-shrink-0 flex-grow-0 pt-6">
                    <span class="d-flex align-center justify-center">
                      <v-avatar
                        size="220"
                        class="style-avatar flex-column justify-center"
                        tile
                      >
                        <div>
                          <v-icon
                            size="35"
                            class="clickable flex-grow-0"
                            color="var(--gray-light)"
                            @click="onPickFile()"
                            >fas fa-image</v-icon
                          >
                          <img
                            :src="selectedFileContent"
                            height="150"
                            @click="onPickFile()"
                          />
                          <input
                            type="file"
                            style="display: none"
                            ref="fileInput"
                            accept="image/*"
                            @change="onFilePicked"
                          />
                          <h6 class="tiny-label mt-2">LOGOTIPO</h6>
                        </div>
                      </v-avatar>
                    </span>
                  </v-col>
                  <!-- form dados básicos ###################################### -->
                  <v-col class="flex-grow-1">
                    <v-container fluid pa-0>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field
                            label="Nome da Secretaria"
                            outlined
                            hide-details="auto"
                            required
                            v-model="secretaryName"
                            :rules="[validateSecretaryName]"
                            :disabled="registerSecretary"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-mask="['##.###.###/####-##']"
                            label="CNPJ"
                            outlined
                            hide-details="auto"
                            required
                            v-model="secretaryDocument"
                            :rules="[validateSecretaryDocument]"
                            :disabled="registerSecretary"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field
                            label="Razão Social"
                            outlined
                            hide-details="auto"
                            required
                            v-model="secretarySocialReason"
                            :rules="[validateSecretarySocialReason]"
                            :disabled="registerSecretary"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <!-- Não remover o botão, usado para quebrar o form no responsivo ################################ -->
                      <v-row>
                        <v-col>
                          <v-btn
                            disabled
                            depressed
                            color="var(--feature)"
                            dark
                            rounded
                            large
                            class="px-12 op-0"
                            @click="showChangePassword = !showChangePassword"
                          >
                            <v-icon class="mr-3" small>fal fa-lock</v-icon
                            >Alterar Senha
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>

        <!-- crud message dialog ###################################### -->
        <CrudMessageResponse
          :showMessage="showSaveSecretaryMessage"
          :message="secretaryCrudMessage"
          @close="crudMessageResponseClose"
        />

        <!-- buttons float ###################################### -->
        <template>
          <v-footer fixed color="transparent" padless class="justify-center">
            <v-card elevation="6" class="pt-3 pb-4 px-4 footer-card">
              <v-btn
                @click="goToSecretariesManagement()"
                color="secondary"
                rounded
                large
                depressed
                class="px-12 mr-1 white--text footer-border-left"
                >Voltar</v-btn
              >
              <v-btn
                color="secondary"
                rounded
                large
                depressed
                class="px-12 ml-1 footer-border-right"
                :disabled="!isSecretaryFormValid"
                @click="saveSecretary()"
                >Salvar</v-btn
              >
            </v-card>
          </v-footer>
        </template>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import NavBar from "@/components/NavBar";
import CommonHelper from "@/scripts/helpers/common.helper";
import EntityService from "@/scripts/services/entity.service";
import Routes from "@/router/names.js";
import CrudMessageResponse from "@/components/CrudMessageResponse";

export default {
  name: "SecretarysRegister",
  components: {
    NavBar,
    CrudMessageResponse
  },
  data: () => ({
    // secretaryObject: "",
    Active: true,
    entityService: new EntityService(),
    registerSecretary: false,

    //Form Info
    isSecretaryFormValid: false,

    // Secreatry Information
    secretaryName: "",
    secretaryDocument: "",
    secretarySocialReason: "",
    secretaryActive: false,

    //Image information
    selectedFile: null,
    selectedFileContent: "",

    //Secretary Data Control
    showSaveSecretaryMessage: false,
    secretaryCrudMessage: "",
    secretaryFromDatabase: {},
    address: {},
    canGoToSecretariesManagement: false,

    //Module Title
    moduleTitle: "Cadastro"
  }),
  computed: {
    ...mapGetters(["selectedSecretary"])
  },
  mounted() {
    if (
      this.$route.params.secretaryId &&
      this.selectedSecretary &&
      this.selectedSecretary.id == this.$route.params.secretaryId
    ) {
      this.moduleTitle = "Edição";

      this.secretaryName = this.selectedSecretary.entityViewModel.name;
      this.secretaryDocument = this.selectedSecretary.entityViewModel.document;
      this.secretarySocialReason = this.selectedSecretary.entityViewModel.socialReason;
      this.secretaryActive = !this.selectedSecretary.entityViewModel.active;
      if (this.selectedSecretary.secretaryLogo.url)
        this.selectedFileContent = this.selectedSecretary.secretaryLogo.url;
      else
        this.selectedFileContent = `data:${this.selectedSecretary.secretaryLogo.contentType};base64, ${this.selectedSecretary.secretaryLogo.content}`;
    } else if (this.$route.params.secretaryId) {
      this.getSecretaryByIdAndFillFields(this.$route.params.secretaryId);
    } else {
      this.setSelectedSecretary(null);
    }
  },
  methods: {
    ...mapActions(["setSelectedSecretary"]),
    getSecretaryByIdAndFillFields(id) {
      this.entityService
        .getSecretaryById(id)
        .then(this.getSecretaryByIdCallBack)
        .catch(this.getSecretaryByIdCatch);
    },
    getSecretaryByIdCallBack(data) {
      this.setSelectedSecretary(data);
      this.secretaryFromDatabase = data;

      this.secretaryName = this.secretaryFromDatabase.entityViewModel.name;
      this.secretaryDocument = this.secretaryFromDatabase.entityViewModel.document;
      this.secretarySocialReason = this.secretaryFromDatabase.entityViewModel.socialReason;
      this.secretaryActive = !this.secretaryFromDatabase.entityViewModel.active;
      if (this.secretaryFromDatabase.secretaryLogo.url)
        this.selectedFileContent = this.secretaryFromDatabase.secretaryLogo.url;
      else
        this.selectedFileContent = `data:${this.secretaryFromDatabase.secretaryLogo.contentType};base64, ${this.secretaryFromDatabase.secretaryLogo.content}`;
    },
    getSecretaryByIdCatch() {},
    saveSecretary() {
      let secretary = {
        entityViewModel: {
          name: this.secretaryName,
          document: this.secretaryDocument,
          socialReason: this.secretarySocialReason,
          active: !this.secretaryActive
        }
      };

      this.showSaveSecretaryMessage = false;

      if (this.selectedSecretary != null) {
        secretary.id = this.selectedSecretary.id;

        this.entityService
          .editSecretary(secretary, this.selectedFile)
          .then(this.crudSecretaryCallBack)
          .catch(this.crudSecretaryCatch);
      } else {
        this.entityService
          .createSecretary(secretary, this.selectedFile)
          .then(this.crudSecretaryCallBack)
          .catch(this.crudSecretaryCallBack);
      }
    },
    crudSecretaryCallBack(response) {
      if(response.errorMessage) return;
      
      this.canGoToSecretariesManagement = true;
      this.showSaveSecretaryMessage = true;

      if (this.selectedSecretary != null) {
        this.secretaryCrudMessage = "Secretaria atualizada com sucesso!";
      } else {
        this.secretaryCrudMessage = "Secretaria criada com sucesso!";
      }
    },
    createSecretaryCatch() {
      this.showSaveSecretaryMessage = true;

      if (this.secretaryId > 0) {
        this.secretaryCrudMessage =
          "Ops, desculpe, não foi possível atualizar, contate o suporte";
      } else {
        this.secretaryCrudMessage =
          "Ops, desculpe, não foi possível cadastrar, contate o suporte";
      }
    },
    closeCreateSecretaryDialogAndCleanFields() {
      this.showSaveSecretaryMessage = false;
      this.secretaryName = "";
      this.secretaryDocument = "";
      this.secretarySocialReason = "";
      this.image = null;
      this.imageUrl = "";
    },
    validateSecretaryName() {
      if (!this.secretaryName) return "Preencha o nome da Secretaria";
      return true;
    },
    validateSecretaryDocument() {
      if (!this.secretaryDocument) return "Preencha o documento";
      if (!CommonHelper.validateCNPJ(this.secretaryDocument))
        return "CNPJ inválido";
      return true;
    },
    validateSecretarySocialReason() {
      if (!this.secretarySocialReason)
        return "Preencha a razão social da Secretaria";
      return true;
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    onFilePicked(event) {
      const files = event.target.files;
      this.selectedFile = files[0];
      let fileName = files[0].name;
      if (fileName.lastIndexOf(".") <= 0) {
        return alert("Por favor adicione um arquivo válido");
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.selectedFileContent = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
    },
    goToSecretariesManagement() {
      this.$router.push({ name: Routes.app.SecretarysManagement });
    },
    crudMessageResponseClose() {
      if (this.canGoToSecretariesManagement) {
        this.goToSecretariesManagement();
      }
    }
  }
};
</script>